export default "__VITE_ASSET__CoW9tOBx__"